//import './app/CookieConsent'
import './app/CourseList'

/**
 * PHONE NUMBER VALIDATION
 */
import intlTelInput from 'intl-tel-input';
document.addEventListener('lazybeforeunveil', function (e) {
    if (e.target.className.match(/\bcustom-phone\b/)) {
        import('intl-tel-input/build/js/utils').then(() => {
            let iti = intlTelInput(e.target, {
                initialCountry: 'auto',
                preferredCountries: ['ch'],
                onlyCountries: ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
                    "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
                    "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
                    "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
                autoPlaceholder: 'aggressive',
                nationalMode: false,
                separateDialCode: true,
                formatOnDisplay: true,
                autoFormat: true,
                hiddenInput: 'full_phone',
                geoIpLookup: function (callback) {
                    fetch('https://ipinfo.io/json', {
                        cache: 'reload'
                    }).then(response => {
                        if (response.ok) {
                            return response.json()
                        }
                        throw new Error('Failed: ' + response.status)
                    }).then(ipjson => {
                        callback(ipjson.country)
                    }).catch(e => {
                        callback('ch')
                    })
                }
            });

            e.target.addEventListener('keyup', function (keyUpEvent) {
                let number = iti.getNumber()
                if (number.match(/^\+410/)) {
                    number = number.replace(/^\+410/, '+41')
                    iti.setNumber(number)
                }
            })
        })
    }
})
